import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

/**
 * This is a utility function that is used for creating a HOC that
 * is used for mapping React props to bootstrap classes. This way we can
 * control the different attributes of our SVG icons with utility classes
 * instead of mapping properties onto the SVG component.
 */ const addPropsToSVG = (IconComponent)=>({ className, size, ...rest })=>{
        return jsx(IconComponent, {
            ...rest,
            className: classNames(className, `icon`, {
                'icon-size-inherit': size === 'inherit',
                'icon-size-responsive': size === 'responsive',
                'icon-size-200': size === 'sm',
                'icon-size-300': !size || size === 'md',
                'icon-size-400': size === 'lg'
            })
        });
    };

export { addPropsToSVG };
